import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-summary-grid',
    templateUrl: './summary-grid.component.html',
    styleUrls: ['./summary-grid.component.css'],
    standalone: false
})
export class SummaryGridComponent {
  @Input()
  columnDefs: any[];

  @Input()
  rowData: any[]

  @Input()
  errorMsg = ''

  @Input()
  isLoading = true

  @Output()
  onTriggerLambda = new EventEmitter<any>()

  constructor() {
    this.rowData = [];
    this.columnDefs = []
  }

  triggerAutomateTool(row: any): void {
    console.log('Triggering automate tool for row:', row);
    this.onTriggerLambda.emit(row)
  }

  getMessage(): string {
    if (this.errorMsg) {
      return this.errorMsg || ''

    } else if (!this.isLoading && !this.rowData.length) {
      return 'sfu_no_data_found'
    }
    return ''
  }

}
